export default {
  'activity.title': 'Activity Title',
  'activity.content': 'Activity Content',
  'activity.coverImage': 'Cover Image',
  'activity.applyEnabled': 'Application Switch',
  'activity.applyEnabled.on': 'On',
  'activity.applyEnabled.off': 'Off',
  'activity.auditMode': 'Audit Mode',
  'activity.auditMode.autoDispatch': 'Auto Dispatch',
  'activity.auditMode.manualReview': 'Manual Review',
  'activity.autoRewardTickets': 'Ticket Reward',
  'activity.cycleType': 'Cycle Type',
  'activity.cycleType.noCycle': 'No Cycle',
  'activity.cycleType.daily': 'Daily',
  'activity.cycleType.weekly': 'Weekly',
  'activity.cycleType.monthly': 'Monthly',
  'activity.applyLimit': 'Application Limit',
  'activity.submissionFields': 'Submission Fields',
  'activity.creator.add': 'Add',
  'activity.fieldType': 'Field Type',
  'activity.fieldTitle': 'Field Title',
  'activity.requiredField': 'Required',
  'activity.options': 'Options',
  'activity.placeholder.enterTitle': 'Please enter title',
  'activity.placeholder.enterOptions': 'Press Enter to confirm',
  'activity.validation.enterTicketReward': 'Please enter ticket reward',
  'activity.validation.ticketRewardRange': 'Please enter an integer between 1 and 99',
  'activity.validation.selectCycleType': 'Please select cycle type',
  'activity.validation.enterApplyLimit': 'Please enter application limit',
  'activity.validation.applyLimitRange': 'Please enter an integer between 1 and 9999',
  'activity.validation.provideOptions': 'Please provide options',
  'activity.validation.optionTooLong': 'A single option cannot exceed 50 characters',
  'activity.validation.optionTooMany': 'You can add up to 50 options',
  'activity.operation': 'Operation',
  'activity.fieldType.option.free': 'Free Fill',
  'activity.review.accountId': 'Account ID',
  'activity.review.pending': 'Pending Review',
  'activity.review.approved': 'Approved',
  'activity.review.rejected': 'Rejected',
  'activity.review.batchAudit': 'Batch Review',
  'activity.review.audit': 'Review',
  'activity.review.approve': 'Approve',
  'activity.review.applicationTime': 'Application Time',
  'activity.review.activityTitle': 'Activity Title',
  'activity.review.applicationCount': 'Application Count',
  'activity.review.submittedData': 'Submitted Data',
  'activity.review.ticketReward': 'Ticket Reward',
  'activity.review.enterRewardCount': 'Please enter reward quantity',
  'activity.fieldType.option.single': 'Single Choice',
  'activity.fieldType.option.multiple': 'Multiple Choice',
  'activity.fieldType.option.image': 'Image',
  'activity.unit.ticket': 'tickets',
  'activity.unit.times': 'times',
  'activity.config.day': 'Day',
  'activity.config.basicReward': 'Basic Reward',
  'activity.config.extraReward': 'Extra Reward',
  'activity.reward.ticket': 'Ticket',
  'activity.reward.bonus': 'Bonus',
  'activity.reward.basicRequired': 'Please enter the basic reward',
  'activity.signIn.limit': 'Limit',
  'activity.signIn.beforeContestLimit': 'Daily tournaments joined before sign-in',
  'activity.signIn.limitRequired': 'Please enter the daily tournaments joined before sign-in',
  'activity.button.add': 'Add',
  'activity.pwa.reward.label': 'Reward',
  'activity.pwa.reward.ticket': 'Ticket',
  'activity.pwa.reward.bonus': 'Bonus',
  'activity.countdown.floatingBall': 'Floating Ball',
  'activity.countdown.cycle': 'Activity Cycle',
  'activity.countdown.week.mon': 'Mon',
  'activity.countdown.week.tue': 'Tue',
  'activity.countdown.week.wed': 'Wed',
  'activity.countdown.week.thu': 'Thu',
  'activity.countdown.week.fri': 'Fri',
  'activity.countdown.week.sat': 'Sat',
  'activity.countdown.week.sun': 'Sun',
  'activity.countdown.config.round': 'Round',
  'activity.countdown.config.countdown': 'Countdown (Mins)',
  'activity.countdown.config.reward': 'Chest Reward',
  'activity.countdown.reward.noRewardTip':
    'No reward. How long after login to display the 1st chest.',
  'activity.countdown.reward.ticket': 'Ticket',
  'activity.countdown.reward.bonus': 'Bonus',
  'activity.countdown.button.add': 'Add',
  'activity.select.modal.title': 'Select Activity Type',
  'activity.select.type.custom.label': 'Custom Activity',
  'activity.select.type.custom.desc':
    'Includes audit mechanism (automatic distribution or manual approval), rewards tickets.',
  'activity.select.type.countdown.label': 'Countdown Chest',
  'activity.select.type.countdown.desc': 'Rewards tickets/bonuses via countdown, repeatable.',
  'activity.select.type.daily.label': 'Daily Sign-in',
  'activity.select.type.daily.desc': 'Rewards tickets/bonuses upon sign-in, repeatable.',
  'activity.select.type.pwa.label': 'PWA Install Reward',
  'activity.select.type.pwa.desc': 'Install PWA to get tickets/bonuses, once per lifetime.',
  'activity.activityType': 'Activity Type',
  'activity.select.type.limited.label': 'Limited Chest',
  'activity.select.type.limited.desc': 'Random rewards tickets/bonuses, repeatable.',
  'activity.select.type.invite.label': 'Limited Invite',
  'activity.select.type.invite.desc': 'Invite friends within a time limit for bonus, repeatable',
  'activity.invite.requiredMatchesPrefix': 'Invitee joins',
  'activity.invite.requiredMatchesSuffix': 'tournaments before the inviter is rewarded',
  'activity.invite.requiredMatchesRange': 'Please enter an integer between 0 and 99',
  'activity.invite.repeatable': 'Repeatable',
  'activity.invite.periodHours': 'Activity Period',
  'activity.invite.periodHoursSuffix': 'hours',
  'activity.invite.periodHoursRange': 'Please enter an integer between 0 and 999',
  'activity.invite.stage': 'Stage',
  'activity.invite.friendCount': 'Friends',
  'activity.invite.bonus': 'Reward',
  'activity.invite.friendCountRange': 'Please enter an integer between 1 and 999',
  'activity.invite.bonusRange': 'Please enter an integer between 1 and 999999',
  'activity.select.type.bindEmail.label': 'Bind Email',
  'activity.select.type.bindEmail.desc': 'Bind an email for tickets/bonus, once per lifetime',
  'activity.bindEmail.reward': 'Reward',
  'activity.bindEmail.ticketRange': 'Please enter an integer between 1 and 99',
  'activity.bindEmail.bonusRange': 'Please enter an integer between 1 and 9999',
  'activity.limited.mechanism': 'Obtaining Mechanism',
  'activity.limited.randomReward': 'Random rewards. Users can receive up to',
  'activity.limited.rounds': 'Rounds',
  'activity.limited.schedule': 'Schedule',
  'activity.limited.validation.selectTimeRange': 'Please select time range',
  'activity.limited.validation.startBeforeEnd': 'Start time must be before end time',
  'activity.limited.validation.startAfterPrev': 'Start time must be after previous round end time',
  'activity.limited.validation.bothInputs': 'Both start and end values must be entered',
  'activity.limited.validation.rightGreaterEqual':
    'Right value must be greater than or equal to left value',
  'activity.limited.validation.enterTicketCount': 'Please enter ticket count',
  'activity.limited.validation.enterBonusAmount': 'Please enter bonus amount',
  'activity.invite.inviteeCondition': 'Invitee Condition',
  'activity.invite.requireKyc': 'Inviter gets the reward after the invitee completes KYC',
  'activity.signIn.allowCrossSiteUser': 'Allow referred users to join',
  'activity.signIn.allowRestrictedUser': 'Allow restricted users to join',
};
